// extracted by mini-css-extract-plugin
module.exports = {"link":"back-link-module--link--jfjZF","icon":"back-link-module--icon--2-rPw","label":"back-link-module--label--29pqZ"};